import httpClient from '@/api/httpClient'

class LocationGroupApi {
  static async fetchLocationGroupList(
    ownerProfileId,
    locationGroupType,
    withoutEmpty = false,
  ) {
    try {
      const res = await httpClient.get(`/location_group`, {
        params: {
          owner_profile_id: ownerProfileId,
          location_group_type: locationGroupType,
          without_empty: withoutEmpty ? 1 : 0,
        },
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  }
  static async addLocationGroup({
    ownerProfileId,
    locationType,
    name,
    accessibleType,
  }) {
    try {
      const res = await httpClient.post(
        `/location_group?owner_profile_id=${ownerProfileId}`,
        {
          name,
          accessibleType,
          locationType: locationType,
        },
      )
      return res.data
    } catch (e) {
      throw Error(e)
    }
  }
  static async editLocationGroup({ locationGroupId, name, accessibleType }) {
    try {
      const res = await httpClient.put(`/location_group/${locationGroupId}`, {
        name,
        status: 'active', // 現段階では絶対に inactive にしたらだめ
        accessibleType,
      })
      return res.data
    } catch (e) {
      throw Error(e)
    }
  }
  static async deleteLocationGroup(id) {
    try {
      httpClient.delete(`/location_group/${id}`)
    } catch (e) {
      throw Error(e)
    }
  }
}

export default LocationGroupApi
